<div class="quotations-page p-fluid">
  <app-page-shell>
    <p-toast></p-toast>
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


    <app-page-hero eyebrow="CRM Quotations" title="Quotations" subtitle="Create generic quotations, enrich POSM quotes when needed, and track approval through client review.">
      <div actions>
        <p-button label="Terms" icon="pi pi-file" severity="secondary" [outlined]="true" (click)="openTermsConfig()"></p-button>
        <p-button label="Workflow Config" icon="pi pi-sitemap" severity="secondary" [outlined]="true" (click)="openWorkflowConfig()"></p-button>
        <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="loadQuotations()"></p-button>
        <p-button label="New Quotation" icon="pi pi-plus" (click)="openNew()"></p-button>
      </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-search-panel title="Search Quotations" [activeFilters]="activeSearchCount()" [collapsed]="true" (clear)="clearSearch()" (search)="applySearch()">
      <div class="search-grid">
        <div class="field">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon><p-iftaLabel><input id="quoteSearch" pInputText [ngModel]="searchText()" (ngModelChange)="searchText.set($event)" (keydown.enter)="applySearch()"><label for="quoteSearch">Global Search</label></p-iftaLabel></p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-tags"></i></p-inputGroupAddon><p-iftaLabel><p-select inputId="quoteTypeSearch" [options]="types" optionLabel="label" optionValue="value" [ngModel]="typeFilter()" (ngModelChange)="typeFilter.set($event || '')" [showClear]="true" styleClass="w-full"></p-select><label for="quoteTypeSearch">Type</label></p-iftaLabel></p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon><p-iftaLabel><p-select inputId="quoteJobTypeSearch" [options]="jobTypes" optionLabel="label" optionValue="value" [ngModel]="jobTypeFilter()" (ngModelChange)="jobTypeFilter.set($event || '')" [showClear]="true" styleClass="w-full"></p-select><label for="quoteJobTypeSearch">Job Type</label></p-iftaLabel></p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon><p-iftaLabel><p-select inputId="quoteStatusSearch" [options]="statuses" optionLabel="label" optionValue="value" [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event || '')" [showClear]="true" styleClass="w-full"></p-select><label for="quoteStatusSearch">Status</label></p-iftaLabel></p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon><p-iftaLabel><p-select inputId="quoteDeviationSearch" [options]="deviationStatuses" optionLabel="label" optionValue="value" [ngModel]="deviationFilter()" (ngModelChange)="deviationFilter.set($event || '')" [showClear]="true" styleClass="w-full"></p-select><label for="quoteDeviationSearch">Criteria Status</label></p-iftaLabel></p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon><p-iftaLabel><p-datepicker inputId="startFrom" [ngModel]="startFrom()" (ngModelChange)="startFrom.set($event)" styleClass="w-full"></p-datepicker><label for="startFrom">Start From</label></p-iftaLabel></p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar-clock"></i></p-inputGroupAddon><p-iftaLabel><p-datepicker inputId="startTo" [ngModel]="startTo()" (ngModelChange)="startTo.set($event)" styleClass="w-full"></p-datepicker><label for="startTo">Start To</label></p-iftaLabel></p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon><p-iftaLabel><p-inputNumber inputId="amountFrom" [ngModel]="amountFrom()" (ngModelChange)="amountFrom.set($event)" styleClass="w-full"></p-inputNumber><label for="amountFrom">Amount From</label></p-iftaLabel></p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon><p-iftaLabel><p-inputNumber inputId="amountTo" [ngModel]="amountTo()" (ngModelChange)="amountTo.set($event)" styleClass="w-full"></p-inputNumber><label for="amountTo">Amount To</label></p-iftaLabel></p-inputGroup>
        </div>
      </div>
    </app-page-search-panel>

    <app-page-data-panel title="Quotation Directory" [subtitle]="lastUpdatedText" [resultText]="quotations().length + ' of ' + totalRecords() + ' records'">
      <p-table
        [value]="quotations()"
        [rows]="rows()"
        [paginator]="true"
        [lazy]="true"
        [totalRecords]="totalRecords()"
        [loading]="loading()"
        [rowHover]="true"
        dataKey="id"
        styleClass="p-datatable-sm p-datatable-gridlines quotations-data-table"
        [tableStyle]="{ 'min-width': '86rem' }"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} quotations"
        [showCurrentPageReport]="true"
        (onLazyLoad)="loadQuotations($event)">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="quotationNumber" style="width: 13rem">Quote <p-sortIcon field="quotationNumber"></p-sortIcon></th>
            <th pSortableColumn="subject">Quotation Profile <p-sortIcon field="subject"></p-sortIcon></th>
            <th pSortableColumn="customerName">Customer / Contact <p-sortIcon field="customerName"></p-sortIcon></th>
            <th pSortableColumn="totalAmount" style="width: 16rem">Pricing <p-sortIcon field="totalAmount"></p-sortIcon></th>
            <th style="width: 17rem">Ownership / Updates</th>
            <th class="text-center" style="width: 8rem">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-quotation>
          <tr>
            <td>
              <div class="stack-cell">
                <span class="code-pill">{{ quotation.quotationNumber || 'DRAFT' }}</span>
                <p-tag [value]="quotation.status" [severity]="getSeverity(quotation.status)"></p-tag>
              </div>
            </td>
            <td>
              <div class="stack-cell">
                <a class="link-button cell-title" [routerLink]="['/crm/quotations', quotation.id]">{{ quotation.subject }}</a>
                <div class="cell-meta">
                  <span><i class="pi pi-tags"></i><b>{{ quotation.jobType || quotation.type || 'Type n/a' }}</b></span>
                  @if (quotation.type === 'POSM') { <span><i class="pi pi-briefcase"></i><b>POSM addon</b></span> }
                  <span><i class="pi pi-calendar"></i>{{ quotation.startDate ? (quotation.startDate | date:'mediumDate') : 'No date' }}</span>
                  @if (quotation.deviationStatus) { <span><i class="pi pi-check-circle"></i>{{ quotation.deviationStatus }}</span> }
                </div>
              </div>
            </td>
            <td>
              <div class="stack-cell">
                <span class="cell-title">{{ quotation.customerName || '-' }}</span>
                <div class="cell-meta vertical">
                  <span><i class="pi pi-user"></i>{{ quotation.pocName || '-' }}</span>
                  <span><i class="pi pi-envelope"></i>{{ quotation.pocEmail || '-' }}</span>
                  @if (quotation.pocPhoneNumber || quotation.pocMobileNumber) {
                    <span><i class="pi pi-phone"></i>{{ quotation.pocPhoneNumber || quotation.pocMobileNumber }}</span>
                  }
                </div>
              </div>
            </td>
            <td>
              <div class="stack-cell">
                <span class="quality-pill">{{ quotation.currencyCode || 'SAR' }} {{ (quotation.totalAmount || 0) | number:'1.2-2' }}</span>
                <div class="cell-meta vertical">
                  <span><i class="pi pi-list"></i>{{ quotation.lines?.length || 0 }} line{{ quotation.lines?.length === 1 ? '' : 's' }}</span>
                  <span><i class="pi pi-minus-circle"></i>Discount {{ (quotation.discountAmount || 0) | number:'1.2-2' }}</span>
                  <span><i class="pi pi-percentage"></i>VAT {{ (quotation.vatAmount || 0) | number:'1.2-2' }}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="stack-cell">
                <span class="cell-title">{{ quotation.salesTeamName || quotation.kamCustomerId || 'Unassigned' }}</span>
                <div class="cell-meta vertical">
                  <span><i class="pi pi-user"></i>Created by {{ quotation.createdByCustomerName || quotation.createdByCustomerId || '-' }}</span>
                  <span><i class="pi pi-calendar-plus"></i>{{ quotation.createdAt ? (quotation.createdAt | date:'medium') : '-' }}</span>
                  <span><i class="pi pi-clock"></i>{{ quotation.updatedAt ? (quotation.updatedAt | date:'medium') : 'Not updated' }}</span>
                </div>
              </div>
            </td>
            <td class="text-center">
              <div class="row-actions">
                <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-text p-button-info" [routerLink]="['/crm/quotations', quotation.id]" pTooltip="View Details"></button>
                @if (canCreateSalesOrder(quotation)) {
                  <button pButton pRipple icon="pi pi-file-plus" class="p-button-rounded p-button-text p-button-success" (click)="createSalesOrder(quotation)" pTooltip="Create Sales Order"></button>
                }
                <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary" (click)="editQuotation(quotation)" pTooltip="Edit"></button>
                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" (click)="deleteQuotation(quotation)" pTooltip="Delete"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">
              <div class="empty-state">
                <i class="pi pi-file-edit"></i>
                <strong>No quotations found</strong>
                <span>No matching quotation records.</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </app-page-data-panel>
  </app-page-shell>
</div>
